import React, {Component} from 'react'

import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'

import AddIcon from '@material-ui/icons/AddCircle'

import PaperBlock from "../../../ui/PaperBlock"

import withStyles from '@material-ui/core/styles/withStyles'

/**
 * <ShopPanel 
 * 		title - заголовок
 * 		shops - выбранные магазины
 * 		
 * 		onAttachShopClick()
 * 		onDetachShopClick(shop)
 * />
 */

class ShopPanel extends Component {

	render() {

		return <PaperBlock style = {{display: "flex", flexDirection: "column", width: "auto"}}>

			<div style = {{display: "flex", justifyContent: "center", alignItems: "center"}}>

				<Typography style = {{flex: "1 1 auto"}}>{this.props.title}</Typography>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onAttachShopClick === "function") {
							this.props.onAttachShopClick()
						}
					}}
				>
					<AddIcon className = {this.props.classes.AddIcon}/>
					Добавить
				</Button>

			</div>

			<div>

				{this.props.shops ? this.props.shops.map((shop, n) => <Chip
					className = {this.props.classes.chip}
					key = {n}
					label = {shop.name}
					onDelete = {() => {
						if (typeof this.props.onDetachShopClick === "function") {
							this.props.onDetachShopClick(shop)
						}
					}}
				/>) : null}

			</div>

		</PaperBlock>
		
	}

}

export default withStyles(theme => ({
	chip: {
		margin: theme.spacing.unit
	},
	AddIcon: {
		marginRight: theme.spacing.unit
	}
}))(ShopPanel)
